module.exports = __webpack_public_path__ + "static/media/blackPrint.04221f7b.svg";